<template>
  <div
    class="bbp-timer-modal"
    @click.stop
  >
    <i
      v-if="!isHideIcon"
      class="bbp-timer-modal__close bbp-icon-cross"
      @click="onClose"
    />
    <div class="bbp-timer-modal-main">
      <BBPTabs
        :tabsList="tabsList"
        :activeTab.sync="activeTab"
        :isSmall="true"
      />
      <BBPTimerModalBody
        :isTimer="activeTab === TIMER_MODAL_TIMER_TAB_ID"
        :row="row"
        :column="column"
        :isSave="isSave"
        :activeTimer="activeTimer"
        :body.sync="body"
        :isErrorComment.sync="isError"
        :isErrorSelect.sync="isErrorSelect"
        :isSubproject="isSubproject"
        :isHourProject="isHourProject"
      />
    </div>
    <button
      class="bbp-button bbp-timer-modal__button"
      :disabled="disabledButton"
      @click="onSave"
    >
      save
    </button>
  </div>
</template>

<script>
import BBPTabs from '@/components/Main/BBPTabs/BBPTabs'
import { TIMER_MODAL_TABS, TIMER_MODAL_TIMER_TAB_ID } from '@/constants/tabs/timerModalTabs'
import { HOURLY } from '@/constants/projectTypes'
import { TIMER_STATUS } from '@/constants/timerStatus'
import { REMINDER_STATUS } from '@/constants/recurReminders'
import updateProject from '@/mixin/updateProject'
import BBPTimerModalBody from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalBody'
import TimerApi from '@/api/Timer/api'

export default {
  name: 'BBPTimerModal',
  components: { BBPTimerModalBody, BBPTabs },
  mixins: [updateProject],
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    isShowModal: {
      type: String,
      default: ''
    },
    isSubproject: {
      type: Boolean,
      default: false
    },
    isHourProject: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tabsList: TIMER_MODAL_TABS,
    activeTab: TIMER_MODAL_TIMER_TAB_ID,
    TIMER_MODAL_TIMER_TAB_ID,
    isSave: false,
    isError: false,
    isErrorSelect: false,
    body: {},
    isClose: true
  }),
  computed: {
    isHideIcon () {
      const { subTimers = {} } = this.activeTimer
      const { status } = subTimers
      return TIMER_STATUS.COMPLETED === status
    },
    disabledButton () {
      const { childrenProjects = [], projectType = {} } = this.row
      if (this.activeTab === TIMER_MODAL_TIMER_TAB_ID) {
        const { subTimers = {} } = this.activeTimer
        const { status } = subTimers
        return this.isError || this.isErrorSelect || TIMER_STATUS.COMPLETED !== status
      }
      if (HOURLY.id === projectType.id) {
        return this.isError || this.isErrorSelect || !childrenProjects.length
      }
      return this.isError
    },
    instanceStatus () {
      const { instanceStatus } = this.column
      return instanceStatus
    },
    isProjectTimer () {
      return REMINDER_STATUS.PROJECT === this.instanceStatus
    },
    showModal: {
      get () {
        return this.isShowModal
      },
      set () {
        this.$emit('update:isShowModal', false)
      }
    },
    isStart: {
      get () {
        return this.$store.getters.isStart
      },
      set (data) {
        this.$store.dispatch('setStart', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    onClose () {
      this.showModal = false
    },
    checkValidation () {
      const { comment = '', companyIsTab, companies = [] } = this.body
      const [company] = companies
      this.isError = !comment
      this.isErrorSelect = companyIsTab && !company
      return this.isError || this.isErrorSelect
    },
    async onSave () {
      if (this.checkValidation()) return
      this.isSave = !this.isSave
      if (this.activeTab === TIMER_MODAL_TIMER_TAB_ID) {
        await this.createSubTimer()
        this.activeTimer = {
          subTimers: {
            status: TIMER_STATUS.SAVED
          }
        }
        this.time = {
          ...this.time,
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
      }
      setTimeout(() => {
        this.showModal = false
        this.$store.dispatch('setShowTimer', false)
      }, 0)
    },
    createBody () {
      const { subprojectId, project, requestProject, subTimers = {} } = this.activeTimer
      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus: this.instanceStatus,
        subTimerId: subTimers._id,
        ...this.body
      }
      return body
    },
    async createSubTimer () {
      const body = this.createBody()
      try {
        const { data } = await TimerApi.createSubTimer(body)
        if (this.isProjectTimer) {
          this.updateProject({
            row: this.row,
            isSubproject: this.isSubproject,
            isHourProject: this.isHourProject,
            data
          })
        } else {
          const { totalTime: newTotalTime } = data
          const { totalTime } = this.row
          this.row.totalTime = totalTime + newTotalTime
          data.user = [{_id: data.user}]
          this.row.comments.unshift(data)
        }
        this.body = {}
        this.$store.dispatch('setShowTimer', false)
      } catch (err) {
        console.error(err)
      }
    },
    async createCommentTimer () {
      const {
        subTimers = {},
        project,
        requestProject,
        subprojectId
      } = this.activeTimer
      const { _id } = subTimers
      const body = {
        ...this.body,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus: this.instanceStatus
      }
      try {
        const { data } = await TimerApi.createCommentTimer(body, _id)
        const { companies } = data
        const { subTimers } = this.activeTimer
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {
            ...subTimers,
            ...this.body,
            companies
          }
        }

        this.$store.dispatch('setShowTimer', true)
      } catch (err) {
        console.error(err)
      }
    }
  },
  watch: {
    body (newVal) {
      if (newVal) this.isError = false
    }
  },
  beforeDestroy () {
    this.showModal = false
    const { subTimers = {} } = this.activeTimer
    const { _id } = subTimers
    if (!_id) return
    this.createCommentTimer()
    this.$store.dispatch('setShowTimer', true)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bbp-timer-modal {
    width: 438px;
    min-height: 426px;
    background: $color-white;
    border-radius: 8px;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    z-index: 5;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: auto;

    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: -1;
    }

    &__close {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 16px;
      top: 14px;
      font-size: 18px;
      width: 24px;
      height: 24px;
      cursor: pointer;
      transition: 0.2s;
      color: $color-silver;
    }

    &__button {
      margin: 0 auto 20px auto;
      width: 103px;
    }
  }

  .bbp-timer-modal-main {
    padding: 36px 18px 18px 18px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModal.vue